// import React, { useEffect, useState } from 'react';
// import { Button, Modal } from 'antd';
// import { ArrowLeftOutlined, PhoneOutlined, WhatsAppOutlined } from '@ant-design/icons';
// import axios from 'axios';
// import { useNavigate } from 'react-router-dom';


// const previewContainerStyle = {
//   width: '365px',
//   minHeight: '557px',
//   maxHeight: '667px',
//   margin: '10px auto',
//   border: '1px solid #ccc',
//   borderRadius: '20px',
//   overflow: 'hidden',
//   boxShadow: '0 0 10px rgba(0,0,0,0.2)',
//   backgroundColor: '#f8f9fa',
//   display: 'flex',
//   flexDirection: 'column',
//   justifyContent: 'flex-start',
//   padding: '10px'
// };

// const DistrictScreen = () => {
//   const [districtData, setDistrictData] = useState([]);
//   const dist = sessionStorage.getItem("dist");
//       const route = sessionStorage.getItem("route");
//         const navigate = useNavigate();

//   useEffect(() => {

//     if (route && dist) {
//       axios.post('https://lionsdirectoryapi.emedha.in/district/get', { route, dist })
//         .then(res => setDistrictData(res.data))
//         .catch(err => console.error("Error fetching district data", err));
//     }
//   }, [dist]);

//   const openDial = (phone) => {
//     window.open(`tel:${phone}`);
//   };

//   const openWhatsApp = (phone) => {
//     window.open(`https://wa.me/91${phone}?text=Hello`, '_blank');
//   };

//   return (
//     <div style={previewContainerStyle}>
//          <div style={{
//       backgroundColor: '#fff',
//       padding: '15px',
//       display: 'flex',
//       alignItems: 'center',
//       justifyContent: 'space-between'
//     }}>
//       <div style={{ display: 'flex', alignItems: 'center' }}>
//         <ArrowLeftOutlined
//           style={{
//             fontSize: '18px',
//             color: '#0e3972',
//             cursor: 'pointer',
//             marginRight: '10px'
//           }}
//           onClick={() => navigate('/home')} // or the correct route for HomeScreen
//         />
//         <h6 style={{ color: '#0e3972', fontWeight: 'bold', margin: 0 }}>{route}</h6>
//       </div>
//     </div>
//       <div style={{ overflowY: 'auto', maxHeight: '100%' }}>
//         {districtData.map((intl) => (
//           <div
//             key={intl.id}
//             style={{
//               backgroundColor: 'white',
//               borderRadius: '10px',
//               margin: '10px 0',
//               padding: '12px',
//               boxShadow: '0 2px 6px rgba(0, 0, 0, 0.1)'
//             }}
//           >
//             <div style={{ textAlign: 'center', marginBottom: '10px' }}>
//               <img
//                 src={intl.photo || require('../img/Llogo.png')}
//                 alt="Profile"
//                 style={{
//                   height: '100px',
//                   width: '100px',
//                   borderRadius: '50%',
//                   border: '2px solid #ccc',
//                   objectFit: 'cover'
//                 }}
//               />
//             </div>
//             <div style={{ backgroundColor: '#f3f4f6', borderRadius: '8px', padding: '10px' }}>
//               <div style={{ fontSize: '18px', fontWeight: 'bold', marginBottom: '4px' }}>{intl.membershipName}</div>
//               <div style={{ fontSize: '16px', color: '#444', marginBottom: '2px' }}>{intl.designation}</div>
//               <div style={{ fontSize: '16px', color: '#666', marginBottom: '6px' }}>{intl.clubName}</div>
//               <Button type="link" icon={<PhoneOutlined />} onClick={() => openDial(intl.mobile)}>
//                 {intl.mobile}
//               </Button>
//             </div>
//             <div style={{ textAlign: 'center', marginTop: '8px' }}>
//               <Button shape="circle" icon={<WhatsAppOutlined />} onClick={() => openWhatsApp(intl.mobile)} style={{ color: 'rgb(37, 211, 102)', borderColor: 'rgb(37, 211, 102)' }} />
//             </div>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default DistrictScreen;


import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { ChevronLeft, ChevronRight, Bell } from 'lucide-react';

const DistrictList = ({ onBack, onSelectItem, styles }) => {
  const [districtCategories, setDistrictCategories] = useState([]);

  useEffect(() => {
    fetchDistrictMenu();
  }, []);

  const fetchDistrictMenu = async () => {
    try {
      const res = await axios.post(
        'https://lionsdirectoryapi.emedha.in/district/menu/get'
      );
      setDistrictCategories(res.data);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div style={styles.scrollArea}>
      {/* Header */}
      <div style={{
        backgroundColor: '#0033A0',
        padding: '15px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        color: 'white'
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
          <ChevronLeft onClick={onBack} style={{ cursor: 'pointer' }} />
          <h2 style={{ fontSize: '18px', margin: 0 }}>District</h2>
        </div>
        <Bell size={20} />
      </div>

      {/* Dynamic Categories */}
      <div style={{ padding: '15px' }}>
        {districtCategories.map((item, index) => (
          <div
            key={index}
            onClick={() => onSelectItem(item.name)}   // 👈 send route
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              padding: '18px 15px',
              backgroundColor: 'white',
              borderRadius: '12px',
              marginBottom: '12px',
              border: '1px solid #eee',
              cursor: 'pointer'
            }}
          >
            <span style={{ fontWeight: '500' }}>
              {item.name}
            </span>
            <ChevronRight size={18} color="#0033A0" />
          </div>
        ))}
      </div>
    </div>
  );
};

export default DistrictList;